import { STORAGE_KEY_PREFIX } from "@/constants";
import log from "../../../utils/logger";

import { inMemoryStorage } from "../utils/in-memory-storage";
import persistedStorage from "../utils/indexeddb";

export enum DOCUMENT_STORAGE_KEY {
  CLASSIFICATIONS = "classifications",
  PROMPTS_USED = "prompts_used",
  ERRORS = "errors",
  PARAGRAPHS = "paragraphs",
}

export function saveToDocumentStorage(key: DOCUMENT_STORAGE_KEY, value: string): boolean {
  inMemoryStorage.setItem(`${STORAGE_KEY_PREFIX}${key}`, value);
  try {
    persistedStorage.setItem(`${STORAGE_KEY_PREFIX}${key}`, value);
  } catch (e) {
    // Log error for debugging purposes
    log.error(`Error in saveToDocumentStorage for key="${key}":`, undefined, e);
  }
  return true;
}

export async function getFromDocumentStorage(key: DOCUMENT_STORAGE_KEY): Promise<string | undefined> {
  let value = undefined;
  // NOTE: stopped using word services beucase of size limitation
  value = inMemoryStorage.getItem(`${STORAGE_KEY_PREFIX}${key}`);
  // if there is nothing in memory, try to get from persisted storage
  if (!value) {
    try {
      value = await persistedStorage.getItem(`${STORAGE_KEY_PREFIX}${key}`);
    } catch (e) {
      // Log error for debugging purposes
      log.error(`Error in getFromDocumentStorage for persistent storage for key="${key}":`, undefined, e);
    }
  }
  return value || undefined;
}

export function deleteAllClassificationDataFromDocumentStorage(): boolean {
  inMemoryStorage.removeItem(`${STORAGE_KEY_PREFIX}${DOCUMENT_STORAGE_KEY.CLASSIFICATIONS}`);
  persistedStorage.removeItem(`${STORAGE_KEY_PREFIX}${DOCUMENT_STORAGE_KEY.CLASSIFICATIONS}`);
  inMemoryStorage.removeItem(`${STORAGE_KEY_PREFIX}${DOCUMENT_STORAGE_KEY.ERRORS}`);
  persistedStorage.removeItem(`${STORAGE_KEY_PREFIX}${DOCUMENT_STORAGE_KEY.ERRORS}`);
  inMemoryStorage.removeItem(`${STORAGE_KEY_PREFIX}${DOCUMENT_STORAGE_KEY.PROMPTS_USED}`);
  persistedStorage.removeItem(`${STORAGE_KEY_PREFIX}${DOCUMENT_STORAGE_KEY.PROMPTS_USED}`);
  inMemoryStorage.removeItem(`${STORAGE_KEY_PREFIX}${DOCUMENT_STORAGE_KEY.PARAGRAPHS}`);
  persistedStorage.removeItem(`${STORAGE_KEY_PREFIX}${DOCUMENT_STORAGE_KEY.PARAGRAPHS}`);
  return true;
}
